import * as React from "react";
import { Fun, IOWidget, mk_widget, option, Options } from "../widget";

export interface StringOptions<o> extends Options {
  readonly_element?:"span" | "p" | "nothing" | "input" | "pre"
  type?:"email"|"text"|"password"
  size?:number
  focus_to_output?:(_:React.FocusEvent<HTMLElement>) => o | null,
  blur_to_output?:(_:React.FocusEvent<HTMLElement>) => o | null,
  keydown_to_output?:(_:React.KeyboardEvent<HTMLInputElement>) => o | null,
  on_click?:(_:React.MouseEvent<HTMLElement>) => o | null
}

interface StringProps<o> {
  options?:StringOptions<o>
  input:string,
  string_to_output:Fun<string,o>
  on_done:(output:o) => void
}

interface StringState<_o> { }

class String<o> extends React.Component<StringProps<o>, StringState<o>> {
  constructor(props:StringProps<o>, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    let onFocus = (e:React.FocusEvent<HTMLElement>) => {
      if (this.props.options && this.props.options.focus_to_output) {
        let res = this.props.options.focus_to_output(e)
        if (res) {
          e.stopPropagation()
          this.props.on_done(res)
          return false
        }
      }
      return true
    }
    let onBlur = (e:React.FocusEvent<HTMLElement>) => {
      if (this.props.options && this.props.options.blur_to_output) {
        let res = this.props.options.blur_to_output(e)
        if (res) {
          e.stopPropagation()
          this.props.on_done(res)
          return false
        }
      }
      return true
    }
    let onKeyDown = (e:React.KeyboardEvent<HTMLInputElement>) => {
      if (this.props.options && this.props.options.keydown_to_output) {
        let res = this.props.options.keydown_to_output(e)
        if (res) {
          e.stopPropagation()
          this.props.on_done(res)
          return false
        }
      }
      return true
    }
    let onClick = (e:React.MouseEvent<HTMLElement>) => {
      if (this.props.options && this.props.options.on_click) {
        let res = this.props.options.on_click(e)
        if (res) {
          e.stopPropagation()
          this.props.on_done(res)
          return false
        }
      }
      return true
    }
    return this.props.options && (this.props.options.readonly && this.props.options.readonly_element != undefined) ?
        this.props.options.type && this.props.options.type == "email" ?
          <a  {...(option("extraProperties", this.props.options) || {})}
              id={option("id", this.props.options)}
              className={option("className", this.props.options)}
              href={`mailto:${this.props.input}`} target="_top"
              style={this.props.options ? this.props.options.style : undefined}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onKeyDown={onKeyDown}
              onClick={onClick}
          >{this.props.input}</a>
        : (this.props.options && this.props.options.readonly_element ?
            (this.props.options.readonly_element == "p" ?
              <p {...(option("extraProperties", this.props.options) || {})}
                  id={option("id", this.props.options)}
                    className={option("className", this.props.options)}
                    key={this.props.options ? this.props.options.key : undefined}
                    style={this.props.options ? this.props.options.style : undefined}
                    onClick={onClick}
                  >
                {this.props.input}
              </p>
            : this.props.options.readonly_element == "pre" ?
              <pre {...(option("extraProperties", this.props.options) || {})}
                   id={option("id", this.props.options)}
                   className={option("className", this.props.options)}
                   key={this.props.options ? this.props.options.key : undefined}
                   style={this.props.options ? this.props.options.style : undefined}
                   onClick={onClick}
              >
                {this.props.input}
              </pre>
            : this.props.options.readonly_element == "span" ?
              <span {...(option("extraProperties", this.props.options) || {})}
                    id={option("id", this.props.options)}
                    className={option("className", this.props.options)}
                    key={this.props.options ? this.props.options.key : undefined}
                    style={this.props.options ? this.props.options.style : undefined}
                    onClick={onClick}
                  >
                {this.props.input}
              </span>
            : this.props.options.readonly_element == "input" ?
            <input {...(option("extraProperties", this.props.options) || {})}
              id={option("id", this.props.options)}
              className={option("className", this.props.options)}
              key={this.props.options ? this.props.options.key : undefined}
              style={this.props.options ? this.props.options.style : undefined}
              size={this.props.options ? this.props.options.size : undefined}
              readOnly={true}
              type={this.props.options ? this.props.options.type : undefined}
              value={this.props.input}
              autoFocus={this.props.options && this.props.options.autofocus}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={onKeyDown}
              onClick={onClick}
              onChange={e => this.props.on_done(this.props.string_to_output(e.currentTarget.value)) } />
            : this.props.input)
        :
          <p {...(option("extraProperties", this.props.options) || {})}
          id={option("id", this.props.options)}
          className={option("className", this.props.options)}
          key={this.props.options ? this.props.options.key : undefined}
          style={this.props.options ? this.props.options.style : undefined}
          onClick={onClick}>
            {this.props.input}
          </p>)
    :
        <input  {...(option("extraProperties", this.props.options) || {})}
                id={option("id", this.props.options)}
                className={option("className", this.props.options)}
                key={this.props.options ? this.props.options.key : undefined}
                style={this.props.options ? this.props.options.style : undefined}
                size={this.props.options ? this.props.options.size : undefined}
                readOnly={this.props.options && this.props.options.readonly}
                type={this.props.options ? this.props.options.type : undefined}
                value={this.props.input}
                autoFocus={this.props.options && this.props.options.autofocus}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                onClick={onClick}
                onChange={e => this.props.on_done(this.props.string_to_output(e.currentTarget.value)) } />
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const string_full = function<o>(string_to_output:Fun<string,o>, options?:StringOptions<o>) : IOWidget<string, o> {
  return (input:string) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<StringProps<o>>(String, { on_done, input, options, string_to_output })
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const string = function(options?:StringOptions<string>) : IOWidget<string, string> {
  return (input:string) => mk_widget({
    run:(on_done:(output:string) => void) =>
      React.createElement<StringProps<string>>(String, { on_done, input, options, string_to_output:x => x })
  })
}
